
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const IdleTimeOutModal = ({showModal, handleClose, handleLogout, remainingTime}) => {

    return (
        <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Are you still there?</Modal.Title>
            </Modal.Header>
            <Modal.Body>If not ,”we will close this session.”</Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={handleLogout}>
            Sign out
            </Button>
            <Button variant="primary" onClick={handleClose}>
            I'm here
            </Button>
            </Modal.Footer>
        </Modal>
    )
}